<template>
    <div>
    </div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "fulfillment",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'fulfillment'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>

</style>